import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { deepmerge } from 'deepmerge-ts';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface TranslationResource {
  prefix: string;
  suffix?: string;
  optional?: boolean;
}

// Minimal replacement for ngx-translate-multi-http-loader: every version of that package
// compatible with Angular 16 forces a '.json' suffix (via `resource.suffix || '.json'`, or
// hardcoded), which silently breaks SimpleLocalize hosting (its published resources have no
// extension). This builds the path from `suffix` exactly as given, including an empty string.
export class SimpleMultiTranslateHttpLoader implements TranslateLoader {
  private readonly http: HttpClient;

  constructor(handler: HttpBackend, private readonly resources: TranslationResource[]) {
    this.http = new HttpClient(handler);
  }

  getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map((resource) => {
      const path = `${resource.prefix}${lang}${resource.suffix ?? ''}`;
      return this.http.get(path).pipe(
        catchError((error) => {
          if (!resource.optional) {
            console.error('Could not load translation file:', path, error);
          }
          return of({});
        })
      );
    });
    return forkJoin(requests).pipe(map((results) => deepmerge(...results)));
  }
}
